"use strict";
"use client";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BottomSheet = BottomSheet;
exports.IMPORTED_SHEET_LIST_CLASS = exports.IMPORTED_SHEET_BODY_CLASS = void 0;
exports.ImportedBottomSheet = ImportedBottomSheet;
exports.useScrollDown = useScrollDown;
var _react = require("react");
var _sheet = require("@design-generated/sheet");
var _sheet2 = require("@design-generated/sheet.wiring");
var _sheet3 = require("@design/ui/sheet");
var _iconButtonActivation = require("../../confirmation-dialog/icon-button-activation");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["description", "confirm", "scrollAreaRef", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var IMPORTED_PANEL_SCROLL_CLASS = "data-[side=bottom]:h-[60vh] gap-0 border-0 bg-transparent p-0 shadow-none [&>div]:min-h-0 [&>div]:flex-1 [&>div>div]:min-h-0 [&>div>div]:flex-1 [&>div>div>div:nth-child(2)]:min-h-0 [&>div>div>div:nth-child(2)]:flex-1";
var IMPORTED_SHEET_BODY_CLASS = exports.IMPORTED_SHEET_BODY_CLASS = "flex min-h-0 min-w-0 flex-1 flex-col gap-1 self-stretch";
var IMPORTED_SHEET_LIST_CLASS = exports.IMPORTED_SHEET_LIST_CLASS = "flex min-h-0 min-w-0 flex-1 flex-col gap-1 self-stretch overflow-y-auto";
function ImportedBottomSheet(_ref) {
  var onClose = _ref.onClose,
    title = _ref.title,
    children = _ref.children,
    _ref$open = _ref.open,
    open = _ref$open === void 0 ? true : _ref$open,
    onEscapeKeyDown = _ref.onEscapeKeyDown;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_sheet3.Sheet, {
    open: open,
    onOpenChange: function onOpenChange(isOpen) {
      return isOpen || onClose();
    },
    "data-sentry-element": "Sheet",
    "data-sentry-component": "ImportedBottomSheet",
    "data-sentry-source-file": "imported-bottom-sheet.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_sheet3.SheetContent, {
      side: "bottom",
      showCloseButton: false,
      "aria-describedby": undefined,
      onEscapeKeyDown: onEscapeKeyDown,
      className: IMPORTED_PANEL_SCROLL_CLASS,
      "data-sentry-element": "SheetContent",
      "data-sentry-source-file": "imported-bottom-sheet.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_sheet3.SheetTitle, {
        className: "sr-only",
        "data-sentry-element": "SheetTitle",
        "data-sentry-source-file": "imported-bottom-sheet.tsx",
        children: title
      }), children]
    })
  });
}
function useScrollDown(scrollArea) {
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasMoreBelow = _useState2[0],
    setHasMoreBelow = _useState2[1];
  (0, _react.useEffect)(function () {
    if (!scrollArea) return;
    var update = function update() {
      return setHasMoreBelow(scrollArea.scrollTop + scrollArea.clientHeight < scrollArea.scrollHeight - 1);
    };
    update();
    scrollArea.addEventListener("scroll", update);
    window.addEventListener("resize", update);
    var mutationObserver = new MutationObserver(update);
    mutationObserver.observe(scrollArea, {
      childList: true,
      subtree: true
    });
    return function () {
      scrollArea.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
      mutationObserver.disconnect();
    };
  }, [scrollArea]);
  return {
    hasMoreBelow: hasMoreBelow,
    scrollDown: function scrollDown() {
      return scrollArea === null || scrollArea === void 0 ? void 0 : scrollArea.scrollBy({
        top: scrollArea.clientHeight,
        behavior: "smooth"
      });
    }
  };
}
function BottomSheet(_ref2) {
  var _scrollAreaRef$curren;
  var description = _ref2.description,
    confirm = _ref2.confirm,
    scrollAreaRef = _ref2.scrollAreaRef,
    children = _ref2.children,
    sheetProps = _objectWithoutProperties(_ref2, _excluded);
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    content = _useState4[0],
    setContent = _useState4[1];
  var scrollArea = content && ((_scrollAreaRef$curren = scrollAreaRef === null || scrollAreaRef === void 0 ? void 0 : scrollAreaRef.current) !== null && _scrollAreaRef$curren !== void 0 ? _scrollAreaRef$curren : content);
  var _useScrollDown = useScrollDown(scrollArea),
    hasMoreBelow = _useScrollDown.hasMoreBelow,
    scrollDown = _useScrollDown.scrollDown;
  var wiring = {
    headerSheetTitle: sheetProps.title,
    close: (0, _iconButtonActivation.closeIconButton)(sheetProps.onClose),
    headerSheetShowDescription: description !== undefined,
    headerSheetDescription: description,
    sheetSlot: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      ref: setContent,
      className: "".concat(IMPORTED_SHEET_BODY_CLASS, " overflow-x-hidden overflow-y-auto"),
      children: children
    }),
    sheetShowFooter: confirm !== undefined,
    button: {
      onClick: sheetProps.onClose
    },
    kbd: {},
    button2: {
      disabled: confirm === null || confirm === void 0 ? void 0 : confirm.isDisabled,
      onClick: confirm === null || confirm === void 0 ? void 0 : confirm.onConfirm
    },
    buttonLabel2: confirm === null || confirm === void 0 ? void 0 : confirm.label,
    kbd2: {},
    sheetShowScroller: hasMoreBelow,
    button3: {
      "aria-label": "Scroll down",
      onClick: scrollDown
    },
    iconCaretDown: {}
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ImportedBottomSheet, _objectSpread(_objectSpread({}, sheetProps), {}, {
    "data-sentry-element": "ImportedBottomSheet",
    "data-sentry-component": "BottomSheet",
    "data-sentry-source-file": "imported-bottom-sheet.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_sheet2.SheetContext.Provider, {
      value: wiring,
      "data-sentry-element": "SheetContext.Provider",
      "data-sentry-source-file": "imported-bottom-sheet.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_sheet.SheetScreen, {
        "data-sentry-element": "SheetScreen",
        "data-sentry-source-file": "imported-bottom-sheet.tsx"
      })
    })
  }));
}